import { Helmet } from "react-helmet";
import BottomNavigationComponent from "../components/navigation/bottomNavigationComponent";
import WebNavigationComponent from "../components/navigation/webNavigationComponent";
import CalculatorTabView from "../sections/calculator/calculatorTabView";

const navOption = 2;

const RateCalculatorPage = () => {
    <Helmet>
        <title>Rate Calculator</title>
    </Helmet>

    return(
        <>
            <WebNavigationComponent defaultIndex={navOption} />
            
            <CalculatorTabView navOption={navOption}/>

            <BottomNavigationComponent defaultIndex={navOption} />
        </>
    );
}

export default RateCalculatorPage;